import { render, staticRenderFns } from "./KpiSettingsTab.vue?vue&type=template&id=3618d6ee&scoped=true"
import script from "./KpiSettingsTab.vue?vue&type=script&lang=ts"
export * from "./KpiSettingsTab.vue?vue&type=script&lang=ts"
import style0 from "./KpiSettingsTab.vue?vue&type=style&index=0&id=3618d6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618d6ee",
  null
  
)

export default component.exports